/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Missmatchdefectp12Inputs */



/**
* | output |
* | --- |
* | "Left/high pump mismatch defect" |
*
* @param {Br_History_Key_Missmatchdefectp12Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_missmatchdefectp12 = /** @type {((inputs?: Br_History_Key_Missmatchdefectp12Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Missmatchdefectp12Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Left/high pump mismatch defect")
	return /** @type {LocalizedString} */ ("Défaut de discordance pompe gauche/haut")
});
export { br_history_key_missmatchdefectp12 as "br_history_key_missmatchDefectP1" }